import React from "react";

const MobileTouchOverlay: React.FC<{
  onTouchStart: (e: React.TouchEvent) => void;
  onTouchEnd: (e: React.TouchEvent) => void;
  settingsOpen: boolean;
  disabled?: boolean;
}> = ({ onTouchStart, onTouchEnd, settingsOpen, disabled = false }) => {
  // Function to check if the touch is in a valid area (not top bar, edit box, or microphone button)
  const handleTouchStart = (e: React.TouchEvent) => {
    e.preventDefault(); // Always prevent default behaviors

    // Only stop propagation if Settings is NOT open
    if (!settingsOpen) {
      e.stopPropagation();
    }
    // If settingsOpen is true, let the event bubble up to Settings component

    // Don't activate if disabled (e.g., when paused)
    if (disabled) {
      return;
    }

    const touch = e.touches[0];
    const element = document.elementFromPoint(touch.clientX, touch.clientY);

    // Check if the touch is on the top bar, text input, or microphone button
    const isTopBar = element?.closest(".top-section");
    const isMicrophoneButton = element?.closest(".mic-button");

    // Only activate if not touching top bar or microphone button
    if (!isTopBar && !isMicrophoneButton) {
      onTouchStart(e);
    }

    // // Prevent default behaviors like magnifying glass and context menu
    // e.preventDefault();
    // e.stopPropagation();
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    e.preventDefault();
    if (!settingsOpen) {
      e.stopPropagation();
    }

    // Don't call onTouchEnd if disabled
    if (disabled) {
      return;
    }

    onTouchEnd(e);
  };

  // Prevent context menu (long press)
  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    return false;
  };

  return (
    <div
      className={`mobile-touch-overlay ${settingsOpen ? "settings-open" : ""}`}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchMove={(e) => e.preventDefault()}
      onContextMenu={handleContextMenu}
    />
  );
};

export default MobileTouchOverlay;